module.exports = __webpack_public_path__ + "img/chip.35abb2ff.svg";